// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M1qh7","left":"styles_left__mDJ-m","right":"styles_right__3VdiS","alert":"styles_alert__1NQeA"};